import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import ReactTooltip from "react-tooltip";
import "./Dashboard.css";

function DashboardLink(props) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(
    () =>
      window.addEventListener("resize", () =>
        setWindowWidth(window.innerWidth)
      ),
    []
  );

  const linkContents = () => {
    return (
      <>
        <div
          className={
            "rounded-lg d-flex flex-column justify-content-center " +
            (props.disabled ? "dashboard-tile" : "dashboard-tile-finished")
          }
          data-tip={props.disabled ? props.disabledText : ""}
          data-for={`disabledMessage${props.index}`}
        >
          <div
            className={
              "m-1 text-white font-weight-bold dashboard-tile-title text-center"
            }
          >
            <b>{props.text.toUpperCase()}</b>
          </div>
          <div className="flex justify-around m-3 text-white text-3xl dashboard-quick-link-card">
            {props.customIcon || (
              <Icon
                name={props.iconName}
                size={windowWidth <= 500 ? "large" : "big"}
                // color="white"
                className="p-0"
              ></Icon>
            )}
          </div>
        </div>
        <ReactTooltip
          backgroundColor="rgb(47, 224, 222)"
          id={`disabledMessage${props.index}`}
          effect="solid"
        />
      </>
    );
  };

  if (props.disabled) {
    return linkContents();
  } else {
    return (
      <Link
        className={props.className ? props.className : ""}
        to={props.pathname}
      >
        {linkContents()}
      </Link>
    );
  }
}

export default DashboardLink;
